import { useQuery, UseQueryResult } from 'react-query';
import { IAvailableGame } from '../types/ITournament';
import { getAvailableGames } from '../api/tournament';
import { QueryKeys } from '../constants';

export function useGetAvailableGames(): UseQueryResult<IAvailableGame[]> {
    return useQuery(QueryKeys.availableGames, () => getAvailableGames(), {
        retry: false,
        staleTime: Infinity,
        cacheTime: 60000,
    });
}
